"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _reactBeautifulDnd = require("react-beautiful-dnd");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _IconDragHandlerFilled = _interopRequireDefault(require("../Icons/IconDragHandlerFilled"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var reorder = function reorder(list, startIndex, endIndex) {
  var result = Array.from(list);

  var _result$splice = result.splice(startIndex, 1),
      _result$splice2 = _slicedToArray(_result$splice, 1),
      removed = _result$splice2[0];

  result.splice(endIndex, 0, removed);
  return result;
};

var DraggableList = function DraggableList(_ref) {
  var children = _ref.children,
      showHandle = _ref.showHandle;

  var _useState = (0, _react.useState)(children),
      _useState2 = _slicedToArray(_useState, 2),
      Items = _useState2[0],
      setItems = _useState2[1];

  var onDragEndHandler = function onDragEndHandler(result) {
    if (!result.destination) {
      return;
    }

    var newItems = reorder(Items, result.source.index, result.destination.index);
    setItems(newItems);
  };

  return /*#__PURE__*/_react.default.createElement(_reactBeautifulDnd.DragDropContext, {
    onDragEnd: onDragEndHandler
  }, /*#__PURE__*/_react.default.createElement(_reactBeautifulDnd.Droppable, {
    droppableId: "droppable"
  }, function (provided, snapshot) {
    return /*#__PURE__*/_react.default.createElement("div", _extends({}, provided.droppableProps, {
      ref: provided.innerRef
    }), Items.map(function (item, index) {
      return /*#__PURE__*/_react.default.createElement(_reactBeautifulDnd.Draggable, {
        key: index.toString(),
        draggableId: index.toString(),
        index: index
      }, function (provided, snapshot) {
        return /*#__PURE__*/_react.default.createElement(DraggableItem, _extends({
          ref: provided.innerRef,
          isDragging: snapshot.isDragging
        }, showHandle ? '' : _extends({}, provided.dragHandleProps), provided.draggableProps), showHandle ? /*#__PURE__*/_react.default.createElement(DragHandle, provided.dragHandleProps, /*#__PURE__*/_react.default.createElement(_IconDragHandlerFilled.default, {
          color: "#C1C1C1",
          size: 20
        })) : '', item);
      });
    }), provided.placeholder);
  }));
};

var DraggableItem = _styledComponents.default.div.withConfig({
  displayName: "DraggableItem"
})(["margin-bottom:15px;position:relative;border-radius:5px;box-shadow:", ";"], function (_ref2) {
  var isDragging = _ref2.isDragging;
  return isDragging ? '0px 10px 30px -10px rgba(0, 0, 0, .2)' : '0px 10px 30px -10px rgba(0, 0, 0, 0)';
});

var DragHandle = _styledComponents.default.div.withConfig({
  displayName: "DragHandle"
})(["position:absolute;top:calc(50% - 10px);left:10px;"]);

DraggableList.propTypes = {
  children: _propTypes.node.isRequired,
  showHandle: _propTypes.bool
};
var _default = DraggableList;
exports.default = _default;